import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SpUserdialogComponent } from '../sp-userdialog/userdialog.component';
import { Categories } from 'src/app/models/categories';
import { label } from 'src/app/constants/labels';
import { BaseAPIService } from 'src/app/shared/services/api.base.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/shared/services/data.service';
import { Applicationstatus } from 'src/app/models/applicationstatus';
import { environment } from 'src/environments/env-proxy';
//const environment = (window as any).__env
@Component({
  selector: 'app-sp-overview',
  templateUrl: './sp-overview.component.html',
  styleUrls: ['./sp-overview.component.scss']
})
export class SpOverviewComponent implements OnInit {
  labels;
  // Enables the desciption state to more or less
  hideme = {};
  // Interface to get categories for each application
  categoriesArray: Categories[] = [];
  // Text area value for request access popup
  textareaVal: string;
  // Length of categories array
  appLen: number;
  // Full page loader
  loading = true;
  serverUrl = environment.serverUrl;

  // All emoji characters ranges
  ranges = [
    '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
    '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
    '\ud83d[\ude80-\udeff]'  // U+1F680 to U+1F6FF
  ];
  termsAccepted = null;
  viewMoreText = '';
  editable = false;
  saveDataPopup = false;
  isAdmin = null;
  // cloned object for revert functionality
  categoryListCopy = null;
  showUploadPopup= false;
  files: [];
  formInvalid = false;
  appId;
  versionLiveData: Object;
  versionLiveNotification: boolean;
  
  
  constructor(private readonly baseService: BaseAPIService, public dialog: MatDialog, private readonly toastr: ToastrService, private readonly authenticationService: AuthenticationService,  private readonly router: Router, private readonly dataService: DataService) { 
  }
  /**
   * initialization  of Overview component
   * returns overview component.
   */
  ngOnInit() {
    this.labels = label;
    // add user
    this.loading = true;
    this.baseService.POST(environment.serverUrl + '/api/user/addUser', '').subscribe((data) => {
      if(!data) {
        // terms accepted conditions check -> API returns false if terms is accepted
        /* istanbul ignore next */
        this.baseService.GET(environment.serverUrl + '/api/User/IsTermsAccepted').subscribe((res) => {
          this.termsAccepted = res;
          if(this.termsAccepted) {
            this.applicationList();
          }
        },
        /* istanbul ignore next */
        (_error) => {
          this.toasterErrorFetch();
        }
        );
      }
    });
    this.isAdmin = this.authenticationService.adminRole;
    this.getVersionLiveNotification();
  }
  // Get all the application list(example: PLC, M2C...etc)
  applicationList() {
    this.baseService.GET(environment.serverUrl + '/api/application').subscribe((data: []) => {
        this.userApplicationList(data);
        this.appLen = data.length;
    },
    /* istanbul ignore next */
    (_error) => {
      this.toasterErrorFetch();
    }
    );
  }
  /**
   * displays appropriate error message in toaster
   */
  /* istanbul ignore next */
  toasterErrorFetch(){
    this.loading = false;
    this.toastr.error(label.errorFetchingDataReloading, '', {
      timeOut: environment.toasterTimeOut
    });
  }
 /**
   * Checking and assigning application status for the buttons (Approved, pending, decline and block)
   */
  userApplicationList(superData) {
    this.baseService.GET(this.serverUrl + '/api/user/api/user/applicationaccess')
      .subscribe((response : Applicationstatus) => {
        console.log('spapi url '+ this.serverUrl)
        console.log(environment)

        this.loading = false;
        this.categoriesArray = superData;
        for (const element of superData) {
          for (const item of element.applicationList) {
            item.statusText = '';
            for (const innerElement of response.applicationStatusDTO) {
              if (item.applicationId === innerElement.applicationId) {
                item.statusText = innerElement.status;
              }
            }
          }
        }
        this.categoryListCopy = JSON.parse(JSON.stringify(this.categoriesArray));
    });
  }
   /**
   * opening dialog on request access / Unblock click 
   */ 
  /* istanbul ignore next */
  openDialog(itemApp, blockStatus): void {
    const dialogRef = this.dialog.open(SpUserdialogComponent, {
      width: '40%',
      data: { textVal: this.textareaVal, appTxtid: itemApp }
    });
    /* istanbul ignore next */
    dialogRef.afterClosed().subscribe(result => {
      if (result !== false && blockStatus === 'blockedBtn') {
        sessionStorage.setItem('applicationId', result.appTxtid.applicationId);
        this.plcBlockUser(result);
      } 
      if (result !== false && blockStatus === '') {
        sessionStorage.setItem('applicationId', result.appTxtid.applicationId);
        this.plcAddUser(result);
      }
    });
  }
  /**
   * redirection to the particular appplication url
   */ 
  /* istanbul ignore next */
  viewTool(itemApp) {
    if (itemApp.applicationName && (itemApp.applicationPath !== null)) {
      const domain = `${environment.redirect_uri}/${itemApp.applicationPath}/`;
      window.location.href = domain;
    }
  }
  /**
   * add description and sent in encoding format
   */ 
  plcAddUser(result) {
    // removing emoji before passing to headers
    let str = result.textVal;
    str = str.replace(new RegExp(this.ranges.join('|'), 'g'), '');
    result.textVal = str;
    const encodeStr = encodeURIComponent(result.textVal);
    this.baseService.POST_USER(result.appTxtid.requestAccessURL, encodeStr, '' )
    .subscribe((_data) => {
      this.callAPi(result);
    },
    /* istanbul ignore next */
    (error) => {
        this.toasterrorUpdate(error);
    });
  }
  /**
   * sent email notification to user based on the application id
   */ 
  callAPi(result) {
    this.baseService.POST(`${this.serverUrl}/api/user/api/user/application/${result.appTxtid.applicationId}/request`, '')
    .subscribe((_response) => {
        this.baseService.POST( `${this.serverUrl}/api/Notification/SendEmailNotificationForRequestAccess/${result.appTxtid.applicationId}`, '' )
        .subscribe((_data) => {
        });
        this.toastr.success(label.requestInitiatedSuccessfully, '', {
          timeOut: environment.toasterTimeOut
        });
      this.applicationList();
    },
    );
  }
  /**
   * add unblock description and sent in encoding format
   */
  plcBlockUser(result) {
    let str = result.textVal;
    str = str.replace(new RegExp(this.ranges.join('|'), 'g'), '');
    result.textVal = str;
    const encodeStr = encodeURIComponent(result.textVal);
    let url = environment.serverPlcUrl;
    if(result.appTxtid.applicationName === 'IA3') {
      url = environment.serverM2CUrl;
    }
    else if(result.appTxtid.applicationName === 'Migration Expert')
    {
      url = environment.serverMeUrl;
    } else {
      //Added To SonarQube Fix
    }
    this.baseService.PATCH_USER( url + '/api/User/UpdateUserDescription', encodeStr, '' )
    .subscribe((_data) => {
      this.callBlockAPi(result);
    },
    /* istanbul ignore next */
    (error) => {
        this.toasterrorUpdate(error);
    });
  }
  /**
   * returns update api error message for toaster
   */
  toasterrorUpdate(error){
    if(error){
    this.loading = false;
    this.toastr.error(label.errorUpdationTryAgain, '', {
      timeOut: environment.toasterTimeOut
    });
    }
  }
  /**
   * sent email notification to user based on the application id
   */
  callBlockAPi(result) {
    this.baseService.POST(`${this.serverUrl}/api/user/api/user/application/${result.appTxtid.applicationId}/request`, '')
    .subscribe((_response) => {
        this.baseService.POST(`${this.serverUrl}/api/Notification/SendEmailNotificationForUnblockAccess/${result.appTxtid.applicationId}`, '' )
        .subscribe((_data) => {
        });
        this.toastr.success(label.requestInitiatedSuccessfully, '', {
          timeOut: environment.toasterTimeOut
        });
      this.applicationList();
    },
    );
  }
  /**
   * logout if terms declined
   */
  /* istanbul ignore next */
  logout() {
    this.authenticationService.logout();
  }
  /**
   * accept terms
   */
  acceptTerms() {
    this.loading = true;
    this.baseService.PATCH(this.serverUrl + '/api/User/UpdateTermsAccepted', "").subscribe((_data) => {
      this.termsAccepted = true;
      this.applicationList();
    },
    /* istanbul ignore next */
    (error) => {
     this.toasterrorUpdate(error);
    }
    );
  }

  /**
   * Enables edit mode
   */
  editMode(val) {
    this.editable = val;
    this.saveDataPopup = false;
  }
  /**
   * save the data in database
   */
  saveData() {
    const temp = [];
    for(const  [index] of this.categoriesArray.entries()) {
      /* istanbul ignore next */
      for (const [applicationListItem] of this.categoriesArray[index].applicationList.entries()) {
        temp.push(this.categoriesArray[index].applicationList[applicationListItem]);
      }
    }
    this.loading = true;
    this.saveDataPopup = false;
    this.baseService.PATCH( this.serverUrl + '/api/application/UpdateApplications',temp)
    .subscribe((_data) => {
      this.loading = false;
      this.editable = false;
      this.applicationList();
      this.toastr.success(this.labels.updateSuccessfully, '', {
        timeOut: environment.toasterTimeOut
      });
    },
    /* istanbul ignore next */
    (error) => {
        this.editable = false;
        this.toasterrorUpdate(error);
    });
  }
  /**
   * Reverts local changes made by user
   */
  revertChanges() {
    this.editable = false;
    this.saveDataPopup = false;
    this.categoriesArray = JSON.parse(JSON.stringify(this.categoryListCopy));
  }
 
  /**
   * redirects respective component
   */
  /* istanbul ignore next */
  redirectTo(item){
    this.dataService.setNewAppInfo({
      name: item.applicationName,
      appId: item.applicationId,
    });
    this.appId = item.applicationId;
    const numArray = [3,5,6,7];
    if(this.appId === 1 || this.appId === numArray[0]){
      if(item.isWebApp === false && item.requestAccessURL){
        window.open(item.requestAccessURL, '_blank');
        this.appId = 0;
      } else {
        this.router.navigate(['/appinfo']);
      }
    }else if(this.appId === numArray[1] || this.appId === numArray[2] || this.appId === numArray[3]){
      if(item.isWebApp === false && item.requestAccessURL){
        console.log(this.appId)
        window.open(item.requestAccessURL, '_blank');
        this.appId = 0;
      }else {
        this.router.navigate(['/comingSoon']);
      }
    }else {
      this.router.navigate(['/']);
    }
  }
  /**
   * validates input fields
   * returns proper error 
   */
  validateData() {
    this.formInvalid = false;
    for(const [item] of this.categoriesArray.entries()) {
      /* istanbul ignore next */
      for (const [applicationListItem] of this.categoriesArray[item].applicationList.entries()) {
        if(this.categoriesArray[item].applicationList[applicationListItem].applicationName.replace(/\s/g, '').length < 1 || 
          this.categoriesArray[item].applicationList[applicationListItem].description.replace(/\s/g, '').length < 1
        ) {
          this.formInvalid = true;
        }
      }
    }
  }

  /*
    * Function to get 'Version is Live' notification headline
    * 
  */
  getVersionLiveNotification() {
    this.baseService.GET_TEXT(environment.serverUrl + '/api/HeadLine/GetNotificationHeadLine').subscribe(data => {
      if(data){
      this.versionLiveData = data;
      this.versionLiveNotification = this.versionLiveData && !!this.isAdmin;
      }else{
        this.versionLiveNotification = false;
      }
    },
     /* istanbul ignore next */
      _error => {
        this.versionLiveNotification = false;
      });
  }
  closeVersionLiveNotification() {
    this.versionLiveNotification = false;
  }

}
